import facepaint from 'facepaint'

export const useBreakpoint = (breakpoints = []) => {
  return facepaint(breakpoints.map(b => `@media(min-width: ${b})`))
}
